import { type BaseItem } from '../common.js';

export enum NoteFieldFormat {
  BoldCompact = 'BOLD_COMPACT',
  BoldStandard = 'BOLD_STANDARD',
  PlainCompact = 'PLAIN_COMPACT',
  PlainStandard = 'PLAIN_STANDARD',
}

export enum ExportFingerprintNote {
  OnPrevisitSubmit = 'ON_PREVISIT_SUBMIT',
  OnCheckIn = 'ON_CHECK_IN',
  OnReadyForProvider = 'ON_READY_FOR_PROVIDER',
  Disabled = 'DISABLED',
}

export enum ExportAllNoteFieldsSection {
  AP = 'A/P',
  Header = 'Header',
}

export enum TimeZonePatientEventOption {
  Local = 'Local',
  Practice = 'Practice',
}

export interface FullPreferenceDetail {
  appendInterpretationsToExam: boolean;
  autoApplyPrevisitFormTemplates: boolean;
  carryCurrentPrevisit: boolean;
  compactTitles: boolean;
  disableNoteExports: boolean;
  disableOrganSystemFields: boolean;
  exportAllNoteFieldsToAP: ExportAllNoteFieldsSection | boolean;
  exportAppointmentNote: boolean;
  exportAsDynamicNote: boolean;
  exportFingerprintNote: ExportFingerprintNote;
  organSystemsFormat: NoteFieldFormat;
  timeZonePatientEvent: TimeZonePatientEventOption;
}

export type PreferenceDetail = Partial<FullPreferenceDetail>;

export type PreferenceOptions = {
  [K in keyof FullPreferenceDetail]: {
    description: string;
    options: FullPreferenceDetail[K][];
    default: FullPreferenceDetail[K];
  };
};

export interface Preference extends BaseItem {
  userId: string;
  // extend with |
  preference: PreferenceDetail;
}
